import { useMemo } from 'react'

import { useSelector } from 'react-redux'

import type { Collection } from 'reducers/menu-collections/menuCollections'
import { getCollections } from 'selectors/menu-collections/getCollections'

export const useCollections = (): Collection[] => {
  const collectionsMap = useSelector(getCollections)

  // useMemo prevents components from infinite renders, Object.values always returns new array
  return useMemo(() => Object.values(collectionsMap), [collectionsMap])
}
